import { STR_FORMAT_PLACEHOLDER } from "../../constants";

export function formatTemplate(template, ...args) {
  let index = 0;
  return template.replace(new RegExp(STR_FORMAT_PLACEHOLDER, "g"), (match) => {
    return typeof args[index] === "undefined" ? match : args[index++];
  });
}
